import React from 'react';

const Subtract = ({width, height, color}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 11 2" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.888672 1.07407H10.222" stroke={color || '#6E6C6C'} strokeWidth="1.5" strokeLinecap="round"
                  strokeLinejoin="round"/>
        </svg>
    );
};
export default Subtract;
